import {
    ErrorBoundary as BaseErrorBoundary,
} from 'react-error-boundary'

import ErrorFallback from './ErrorFallback'

const ErrorBoundary = ({
    children,
}: Readonly<{
    children: React.ReactNode
}>) => {
    return (
        <BaseErrorBoundary
            FallbackComponent={ErrorFallback}
        >
            {children}
        </BaseErrorBoundary>
    )
}

export default ErrorBoundary
